const domReady = new Promise((resolve, reject) => {
	const { readyState } = document;

	function onReady() {
		resolve();
		document.removeEventListener('DOMContentLoaded', onReady, true);
		window.removeEventListener('load', onReady, true);
	}

	if (readyState === 'interactive' || readyState === 'complete'){
		resolve(document);
	} else {
		document.addEventListener('DOMContentLoaded', onReady, true);
		window.addEventListener('load', onReady, true);
	}
});

export default domReady;



// WEBPACK FOOTER //
// ./mobile-core/src/utils/dom-ready.js